// extracted by mini-css-extract-plugin
export default {"Container":"BzIbgKqZxA_egUPxQYmR"};